module.exports = __webpack_public_path__ + "static/media/uiuxIcon.a4dab7de.svg";